// src/date-input-handler.mjs

import { 
    formatDateInput, 
    isCompleteDateInput, 
    markDateInvalid,
    parseDateInput 
} from "./date-input.mjs";

/**
 * Handles backspace for date inputs with hyphen masks.
 * @param {KeyboardEvent} event 
 * @returns {void}
 */
export function handleDateBackspace(event) {
    if (event.key !== 'Backspace') return;

    const input = /** @type {HTMLInputElement} */ (event.target);
    const { selectionStart, selectionEnd, value } = input;

    if (selectionStart === null || selectionStart !== selectionEnd || selectionStart === 0 || input.value.length === 1) {
        markDateInvalid(input, false);  // clear marking when input becomes empty
        return;
    }

    // Cursor is directly after a hyphen (e.g., "01-12-|") -> turns into "01-1"
    if (selectionStart > 1 && value[selectionStart - 1] === '-') {
        event.preventDefault();
        const newValue = value.slice(0, selectionStart - 2) + value.slice(selectionStart);
        const newPos = selectionStart - 2;

        input.value = newValue;
        input.setSelectionRange(newPos, newPos);
        return;
    }

    // Cursor is directly after a single digit post-hyphen (e.g., "01-12-2|") -> turns into "01-12-"
    if (selectionStart > 2 && value[selectionStart - 2] === '-') {
        event.preventDefault();
        const newValue = value.slice(0, selectionStart - 1) + value.slice(selectionStart);
        const newPos = selectionStart - 1;

        input.value = newValue;
        input.setSelectionRange(newPos, newPos);
    }
}

/**
 * Formats date input on typing while preserving backspace deletions.
 * @param {Event} event 
 * @returns {void}
 */
export function handleDateInput(event) {
    const inputEvent = /** @type {InputEvent} */ (event);

    // Skip auto-formatting if the user is deleting
    if (inputEvent.inputType === 'deleteContentBackward' || inputEvent.inputType === 'deleteContentForward') {
        return;
    }

    const inputElement = /** @type {HTMLInputElement} */ (inputEvent.target);

    const formatted = formatDateInput(inputElement.value);
    
    if (formatted !== inputElement.value) {
        inputElement.value = formatted;
    }

    if (isCompleteDateInput(inputElement.value)) {
        markDateInvalid(inputElement, !parseDateInput(inputElement.value));
    } else {
        markDateInvalid(inputElement, false);
    }
}

/**
 * Formatering af dato, når feltet mister fokus (blur)
 * @param {Event} event 
 * @returns {void}
 */
export function handleDateBlur(event) {
    const inputEvent = /** @type {InputEvent} */ (event);
    const inputElement = /** @type {HTMLInputElement} */ (inputEvent.target);

    if (!inputElement) return;

    const parsedDate = parseDateInput(inputElement.value);
    if (parsedDate) {
        inputElement.value = parsedDate.toFormat('dd-MM-yyyy');
        markDateInvalid(inputElement, false);
    }
}